import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalInstance } from '../msalInstance';
import { apiRequest } from '../authConfig';

// Hardcoded/example data objects
/* const sample_committee = require('../sample_committee.json')
const sample_docs = require('.././sample_docs.json') */ 
/* const misc_committee_actions = require('../sample_misc_committee_actions.json')
const misc_actions = require('../sample_misc_actions.json') */
/* const agendaData = {
    committee_name: sample_committee.name,
    next_meeting: "2025-03-10",
    last_meeting: "2024-10-18",
    schedule_image: "/schedule.png",
    docs: sample_docs,
    meeting_number: 26,
    title: sample_committee.title,
    members: sample_committee.members, 
    contact: sample_committee.contact,
    location: "Online"
}; */

/* const onlineMeeting = {
    url: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZDUwMDYwNWItMTU2Yy00NzAzLTk1YjgtOTY5NDJiOGNhNzNm%40thread.v2/0?context=%7b%22Tid%22%3a%221cf03aab-f64b-4b32-8104-053650fe23cd%22%2c%22Oid%22%3a%220d26a200-c171-4ad3-a506-95ed593a25a9%22%7d",
    id: "1111111",
    passphrase: "12345678"
} */

// const previousProtocol = 'https://collaborate.iec.ch/#/pages/workspaces/567414/documents/null/details/860915?onlyWithPreview=false&fileId=860915'

const baseURL = process.env.REACT_APP_BACKEND_URL;

async function getAuthHeader() {
    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) {
        throw new Error('No signed-in account found');
    }

    try {
        const result = await msalInstance.acquireTokenSilent({ ...apiRequest, account });
        return `Bearer ${result.accessToken}`;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            await msalInstance.acquireTokenRedirect({ ...apiRequest, account });
        }
        throw error;
    }
}

// Every backend call in this file goes through this wrapper so the bearer
// token only has to be attached in one place instead of at every call site.
async function authorizedFetch(url, options = {}) {
    const headers = new Headers(options.headers || {});
    headers.set('Authorization', await getAuthHeader());
    return fetch(url, { ...options, headers });
}

const normlizeFoldersName = (fileName) => {
    const dotIndex = fileName.lastIndexOf('.'); 
    const name = dotIndex !== -1 ? fileName.slice(0, dotIndex) : fileName
    const ext = dotIndex !== -1 ? fileName.slice(dotIndex) : ''; 

    const normalizedName = name
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s.-]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase();

    return `${normalizedName}${ext}`
}; 

/* AGENDA GENERATOR */ 
export async function generateAgenda(committeeInformation, iecDocs, onlineMeeting, misc_committee_actions, misc_actions, recurringTopics, agendaData, reportsIecClc, clcDocs, proposalForSweTitles, recentlyDeterminedPubl) {
    const formData = new FormData();
    formData.append("committee", JSON.stringify(committeeInformation));
    formData.append("docs", JSON.stringify(iecDocs));
    formData.append("online_meeting", JSON.stringify(onlineMeeting));
    formData.append("misc_committee_actions", JSON.stringify(misc_committee_actions));
    formData.append("misc_actions", JSON.stringify(misc_actions));
    formData.append("recurring_topics", JSON.stringify(recurringTopics));
    formData.append("meeting_number", agendaData.meeting_number);
    formData.append("location", agendaData.location);
    formData.append("previous_protocol", agendaData.previous_protocol);
    formData.append("table_of_content", JSON.stringify(agendaData.table_of_content));
    formData.append("language", JSON.stringify(agendaData.language));
    formData.append("reports_IEC_CLC", JSON.stringify(reportsIecClc));
    formData.append("clc_docs", JSON.stringify(clcDocs));
    formData.append("new_titles", JSON.stringify(proposalForSweTitles));
    formData.append("recently_determined_publications", JSON.stringify(recentlyDeterminedPubl));

    try {
        if (agendaData.schedule_image && agendaData.schedule_image !== null) {
            const image = agendaData.schedule_image
            const response = await fetch(image.data);
            const blob = await response.blob();

            const file = new File(
                [blob],
                image.name, 
                {
                    type: image.type,
                    lastModified: image.lastModified
                }
            )
            formData.append("schedule_image", file, file.name);
        } 

        const response = await authorizedFetch(`${baseURL}agenda`, {
            method: "POST",
            body: formData
        });

        if (response.ok) {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
        
            const contentDisposition = response.headers.get("Content-Disposition");
            let fileName = "downloaded_agenda.docx";
            
            if (contentDisposition) {
                let match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);
                
                if (match && match[1]) {
                    fileName = decodeURIComponent(match[1]);
                } else {
                    match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        fileName = match[1].replace(/['"]/g, '');
                    }
                }
            }
        
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } else {
            console.error("Failed to generate agenda:", await response.json());
        }
    } catch (error) {
        console.error("Error:", error);
    }
}

export async function getCommitteeList(){
    try{
        const url = `${baseURL}committees`
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
       //  console.log(json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getDocumentData(committee, lastMeeting, nextMeeting) {
    try {
        const url = `${baseURL}docs?committee=${committee}&last_meeting_date=${lastMeeting}&next_meeting_date=${nextMeeting}`;
        const response = await authorizedFetch(url, {
            method: 'GET',
        });

        const json = await response.json();
        // console.log(json)
        return json;
    } catch (error) {
        console.error('Error fetching data:', error.message);
    }
}

export async function getMeetingDates(committee = 'TK 1') {
    try{
        const url = `${baseURL}meetings?committee=${committee}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        // console.log(json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getCommitteeMembers(committee = 'TK 1') {
    try{
        const url = `${baseURL}members?committee=${committee}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });
        
        const json = await response.json();
        // console.log(json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getProposalForSweTitles(committee){
    try{
        const url = `${baseURL}new_titles?committee=${committee}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        // console.log(json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getRecentlyDeterminedPublications(committee){
    try{
        const url = `${baseURL}recently_determined_publications?committee=${committee}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        // console.log('fastställda', json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getCommittee(committee, lastMeeting){
    try{
        const url = `${baseURL}committees?committee=${committee}&last_meeting_date=${lastMeeting}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        // console.log(json)
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

/* REPORT GENERATOR */
export async function getProposalReport(dopDate, dowDateFrom, dowDateTo) {
    try{
        const url = `${baseURL}proposal_report?dop=${dopDate}&dow_from=${dowDateFrom}&dow_to=${dowDateTo}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        // console.log(json)
        return json
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getPublicationReport(dopDatePL, dowDateFrmPL, dowDateToPL) {
    try{
        const url = `${baseURL}publication_report?dop=${dopDatePL}&dow_from=${dowDateFrmPL}&dow_to=${dowDateToPL}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        return json
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getAnnualReport(year)  {
    try{
        const url = `${baseURL}annual_report?year=${year}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        return json
    }
    catch(error){
        console.error(error.message)
    }
}

export async function getQuarterlyReport(startMonth, endMonth, year)  {
    try{
        const url = `${baseURL}quarter_publication_report?start_month=${startMonth}&end_month=${endMonth}&year=${year}`;
        const response = await authorizedFetch(url, {
            method: "GET",
        });

        const json = await response.json();
        return json
    }
    catch(error){
        console.error(error.message)
    }
}

export async function generateProposalReport(dates, report) {
    try {
        const response = await authorizedFetch(`${baseURL}proposal_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dop: dates.dopDate,
                standards_publish: report.standardsPublish,
                standards_annulment: report.standardsAnnulment,
                TR_publish: report.trPublish,
                TS_publish: report.tsPublish,
            }),
        });

        if (!response.ok) {
            console.error("Failed to generate proposal list:", await response.json());
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        let fileName = "downloaded_proposal_report.zip";

        const contentDisposition = response.headers.get("Content-Disposition");

        if (contentDisposition) {
            let match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);

            if (match && match[1]) {
                fileName = decodeURIComponent(match[1]);
            } else {
                match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }
        }

        a.href = url;
        a.download = normlizeFoldersName(fileName);

        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (error) {
        console.error("Error:", error);
    }
}; 

export async function generatePublicationReport(dates, report) {
    try {
        const response = await authorizedFetch(`${baseURL}publication_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                dop: dates.dopDate,
                standards_publish: report.standardsPublish,
                standards_annulment: report.standardsAnnulment,
                altered_publ_form: report.alteredPublForm,
                added_value: report.addedValue, 
                TR_publish: report.trPublish,
                TS_publish: report.tsPublish,
                iec_as_sek_TR: report.iecAsSekTr,
                iec_as_sek_TS: report.iecAsSekTs,
                iec_as_sek_publ: report.iecAsSekPubl,
            }),
        });

        if (!response.ok) {
            console.error("Failed to generate proposal list:", await response.json());
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        let fileName = "downloaded_publication_report.zip";

        const contentDisposition = response.headers.get("Content-Disposition");

        if (contentDisposition) {
            let match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);

            if (match && match[1]) {
                fileName = decodeURIComponent(match[1]);
            } else {
                match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }
        }

        a.href = url;
        a.download = normlizeFoldersName(fileName);

        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (error) {
        console.error("Error:", error);
    }
}; 

export async function generateQuarterlyReport(dates, report) {
    try {
        const response = await authorizedFetch(`${baseURL}quarter_publication_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                start_month: Number(dates.startMonth),
                end_month: Number(dates.endMonth),
                year: Number(dates.year), 
                standards_publish: report.standardsPublish,
                standards_annulment: report.standardsAnnulment,
                altered_publ_form: report.alteredPublForm,
                added_value: report.addedValue, 
                TR_publish: report.trPublish,
                TS_publish: report.tsPublish,
                iec_as_sek_publ: report.iecAsSekPubl,
                iec_as_sek_TR: report.iecAsSekTr,
                iec_as_sek_TS: report.iecAsSekTs,
                handbooks: report.handbooks,
                tekniklitteratur: report.tekniklitteratur
            }),
        });

        if (!response.ok) {
            console.error("Failed to generate proposal report:", await response.json());
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a"); 

        let fileName = "downloaded_quarterly_report.zip";

        const contentDisposition = response.headers.get("Content-Disposition");

        if (contentDisposition) {
            let match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);

            if (match && match[1]) {
                fileName = decodeURIComponent(match[1]);
            } else {
                match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }
        }; 

        a.href = url;
        a.download = normlizeFoldersName(fileName);

        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (error) {
        console.error("Error:", error);
    }
}; 

export async function generateAnnualReport(year, annualReport) {
    try {
        const response = await authorizedFetch(`${baseURL}annual_report`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                year: year,
                standards_publish: annualReport.standards_publish,
                altered_publ_form: annualReport.altered_publ_form,
                TR_TS: annualReport.TR_TS,
                handbooks: annualReport.handbooks,
                tekniklitteratur: annualReport.tekniklitteratur,
                active_standards: annualReport.active_standards, 
                active_TR: annualReport.active_TR,
                active_TS: annualReport.active_TS,
                active_CWA: annualReport.active_CWA,
                active_handbooks: annualReport.active_handbooks,
                active_tekniklitteratur: annualReport.tekniklitteratur,
                annulled: annualReport.annulled,
            }),
        });

        if (!response.ok) {
            console.error("Failed to generate annual report:", await response.json());
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a"); 

        let fileName = "downloaded_annual_report.zip";

        const contentDisposition = response.headers.get("Content-Disposition");

        if (contentDisposition) {
            let match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/);

            if (match && match[1]) {
                fileName = decodeURIComponent(match[1]);
            } else {
                match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
            }
        }; 

        a.href = url;
        a.download = normlizeFoldersName(fileName);

        document.body.appendChild(a);
        a.click();
        a.remove();
    } catch (error) {
        console.error("Error:", error);
    }
}; 

/* OFFICE MEETINGS */
export async function getDailyMeetings(){
    try{
        const url = `${baseURL}daily-meetings`;
        const response = await fetch(url, {
            method: "GET",
        });

        const json = await response.json();
        return json;
    }
    catch(error){
        console.error(error.message)
    }
}

/* VISMA */
// These throw on failure so the Visma page can show the error message.
async function vismaRequest(url, options) {
    const response = await authorizedFetch(url, options);
    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
        throw new Error(json.details || json.error || `Request failed (${response.status})`);
    }
    return json;
}

export async function getVismaClients() {
    return vismaRequest(`${baseURL}visma/clients`, { method: "GET" });
}

export async function getVismaAuthorizeUrl(client, state) {
    const params = new URLSearchParams({ client, state });
    const json = await vismaRequest(`${baseURL}visma/authorize_url?${params}`, { method: "GET" });
    return json.url;
}

export async function exchangeVismaCode(client, code) {
    return vismaRequest(`${baseURL}visma/exchange`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ client, code })
    });
}